import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	height: "1em",
	viewBox: "0 0 20 20",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0ZM8 15l-5-5 1.4-1.4L8 12.2l7.6-7.6L17 6l-9 9Z",
	fill: "currentColor",
	fillRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgCheckCircle);
export default ForwardRef;
